import { Component, ElementRef, inject, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GamesService } from '../../../services/games/games.service';
import { ToasterService } from '../../../services/toaster/toaster.service';

export interface PromptGameInfo {
  id: string;
  title: string;
}

@Component({
  selector: 'app-update-game-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './update-game-modal.html',
  styleUrl: './update-game-modal.scss',
})
export class UpdateGameModal {
  private gamesService = inject(GamesService);
  private toaster = inject(ToasterService);
  private el = inject(ElementRef);

  public game = input<PromptGameInfo | null>(null);
  public gameUpdated = output<void>();

  /*
   * Opens native OS folder browser to locate game executable/installation directory.
   * Emits gameUpdated and shows success toast if path is selected.
   */
  public async browseGamePath(): Promise<void> {
    const target = this.game();
    if (!target) return;

    // Trigger Electron file dialog
    const res = await this.gamesService.browseGamePath(target.id);
    if (res.success && (res.path || res.executable || res.installed)) {
      this.toaster.success(`${target.title} installation folder updated.`);
      this.gameUpdated.emit();
      this.closeModal();
    }
  }

  /*
   * Closes the Bootstrap modal dialog.
   */
  public closeModal(): void {
    const closeBtn = this.el.nativeElement.querySelector('[data-bs-dismiss="modal"]');
    if (closeBtn) {
      closeBtn.click();
    }
  }
}
